import 'vxe-table-quantdata/lib/style.css'
import {reportYear} from '../../util/util'
import Vue from 'vue'
import XEUtils from "xe-utils";
import InputFilter from '../components/InputFilter'
import httpManager from "../../util/common";

Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  components: {InputFilter},
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      data: [],
      report_type: 'rating',
      ratings: [],
      report_date: [],
      ratings_condition: [],
      filters: [],
      loading: false,
      exportConfig: {},
      report_list: [],
      report_rating_list: [],
      report_year_list: [],
      report_month_list: [],
      gics: null,
      gics_option:null,
      gics_options: null,
      select_option:null,
      select_options: null,
      rating_options: null,
      indicator_month_options: null,
      indicator_annual_options: null,
      indicator_unit: null,
      indicator_data_type: null,
      rating_indicator_map: null,
      isCheckable:true,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number','NextPage'],
        perfect: true,
        pagerCount: 3,
      },
      tableColumn: [],
    }
  },
  methods: {
    openDataExport() {
      let s = "ESG筛选器"
      this.$refs.xTable_data.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv']
      })
    },
    generateReport() {
      this.report_year_list = reportYear.esg_report_years
      let self = this
      let promise1 = reportYear.esg_report_month().then(result => {
        self.report_month_list = result.report_month_list
        self.report_rating_list = result.report_list
        self.report_year_list = result.report_annual_list
        self.report_list = self.report_rating_list
        self.report_date = self.report_list[0]
      })
      let lang = this.$i18n.locale
      let promise2 = reportYear.gics("gics_tree_" + lang).then(result => {
        self.gics_options = result
      })
      let promise3 = reportYear.esg_meta().then(result => {
        self.rating_options = result['rating_tree_' + lang]
        self.indicator_month_options = result['month_tree_' + lang]
        self.indicator_annual_options = result['annual_tree_' + lang]
        self.indicator_unit = result['indicators_unit_' + lang]
        self.indicator_data_type = result['indicators_data_type']
        self.select_options = self.rating_options
        self.rating_indicator_map = result['rating_indicator_map']
      })
      return [promise1,promise2,promise3]
    },
    ratingFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    gicsFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    gicsOnChange(value, selectedOptions)
    {
      this.gics = value[value.length-1]
    },
    pageChange({currentPage, pageSize}) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getESGData()
    },
    changeReportSelect() {
      if (this.report_type === 'rating') {
        this.report_list = this.report_rating_list
        this.select_options = this.rating_options
        this.isCheckable = true
      } else if (this.report_type === 'monthly') {
        this.report_list = this.report_month_list
        this.select_options = this.indicator_month_options
        this.isCheckable = false
      } else {
        this.report_list = this.report_year_list
        this.select_options = this.indicator_annual_options
        this.isCheckable = false
      }
      this.filters=[]
    },
    search() {
      this.page.currentPage = 1
      this.getESGData()
    },
    getESGData() {
      let self = this
      let condition_order = {}
      for(let d in self.filters){
        if(self.filters[d]['rating_indicator'])
          condition_order[`${self.filters[d]['rating_indicator'].toLowerCase().replaceAll(" ", "_")}_${self.filters[d]['report_date']}`] = d
      }
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      if (self.report_type)
        params.set("report_type", self.report_type)
      if (self.gics)
        params.set("gics", self.gics)
      if (self.filters && self.filters.length > 0){
        self.filters.forEach(element => {
          if(!element.rating_condition || !element.rating_condition[0]) {
              element.rating_condition = ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC', 'CC', 'C']
          }
        })
        params.set("filters", JSON.stringify(self.filters))
      } else {
        let filter = {
          report_date: self.report_rating_list[0],
          rating_indicator: 'esg',
          rating_indicator_unit: undefined,
          rating_indicator_data_type: 'rating',
          rating_indicator_options: null,
          rating_condition: ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC', 'CC', 'C']
        }
        params.set("filters", JSON.stringify([filter]))
      }
      self.loading = true
      httpManager("esg_filter", params, null, null, null)
        .then(response => {
          self.data = response.data.data
          // 按照第一个筛选条件的分数逆序排列
          let fisrt_params=self.filters[0]['rating_indicator'].toLowerCase()+'_'+self.filters[0]['report_date']
         // 若为第三级条件 将空格转换为'_'
          fisrt_params=fisrt_params.replace(' ','_')
          // 将一级筛选条件的结果后面的数值保存在新属性中
          for(let item of self.data){
            item.val=parseFloat(item[fisrt_params].slice(item[fisrt_params].indexOf('/')+1))
          }
          // 倒序排序
          self.data.sort((obj1,obj2)=>obj2.val-obj1.val)

          self.tableColumn = []
          self.tableColumn.push(...self.tableColumn_raw)
          if(self.data.length > 0){
            for(let k in self.data[0]){
              if(k != "ticker" && k != "official_name" && k != "val"){
                let code = k.substr(0, k.lastIndexOf("_"))
                let time = k.substr(k.lastIndexOf("_")+1)
                let title = self.rating_indicator_map[code][this.$i18n.locale] + "  " + time
                let index = parseInt(condition_order[k]) ? parseInt(condition_order[k]) + 3 : 3
                self.tableColumn[index] = {title: title, field: k}
              }
            }
          }
          let page = response.data.page
          self.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
    deleteFilter(index){
      this.filters.splice(index,1);
    },
    addFilter() {
      let self = this
      let filter = {
        report_date: self.report_list[0],
        rating_indicator: null,
        rating_indicator_view: null,
        rating_indicator_unit: null,
        rating_indicator_data_type: null,
        rating_indicator_options: null,
        rating_condition: null,
      }
      filter.ratingOnChange=function(value, selectedOptions)
        {
          this.rating_indicator = value[value.length-1]
          this.rating_indicator_unit = self.indicator_unit[this.rating_indicator]
          let data_type = self.indicator_data_type[this.rating_indicator]
          if(['varchar', '文本'].indexOf(data_type)){
            this.rating_indicator_options = self.makeOptions(this.rating_indicator_unit)
          }else{
            this.rating_indicator_options = null
          }
          if(this.rating_indicator_options){
            this.rating_indicator_unit = null
          }
          if(self.report_type === 'rating'){
            this.rating_indicator_data_type = "rating"
          }else{
            this.rating_indicator_data_type = this.rating_indicator_options?"select":self.indicator_data_type[this.rating_indicator]
          }

        }.bind(filter)

      self.filters.push(filter)
    },
    clearFilter() {
      this.filters = []
      this.gics_option=[""]
      this.select_option=[""]
      this.gics=null
      this.report_type = 'rating'
      this.addFilter()
    },
    cellClickEvent({column, row}) {
        const {
        href
      } = this.$router.resolve({path:  '/entity/'+row.official_name+'/home'})
      window.open(href, '_blank')
    },
    makeOptions(unit){
      if(!unit) return null
      let options = null
      if(unit.indexOf("/")!=-1){
        let os = unit.split("/")
        options = []
        os.forEach(function (k) {
          if(k.indexOf("-")!=-1){
            let o = k.split("-")
            options.push({label:o[0], value:o[1]})
          }else{
            options.push({label:k, k})
          }
        })
      }
      return options
    },
  },
  mounted() {
    Promise.all(this.generateReport())
      .then(() => {
      if(this.$route.params!={}) {
        let industry = this.$route.params.industry
        let head_2 = industry ? industry.slice(0,2) : ""
        let gics_option = [head_2]
        let input_value = ""
        this.gics_options.forEach(element => {
          if(element.value == head_2){
            input_value += element.label
            element.children.forEach(ele => {
              if(ele.value == industry){
                gics_option.push(ele.value)
                input_value += ' / ' + ele.label
              }
            })
          }
        })
        this.$nextTick(()=>{
          let gics_cascader = this.$refs.gics_cascader
          this.gicsOnChange(gics_option)
          gics_cascader.inputValue = input_value
          this.filters[0].rating_indicator='esg'
          this.filters[0].rating_indicator_data_type='rating'
          this.filters[0].rating_condition=["AAA","AA","A","BBB","BB","B","CCC","CC","C"]
          this.getESGData()
        })
      }
      this.addFilter()

    })
  },
  watch: {
    report_type: function () {
      this.changeReportSelect()
    }
  },
  created() {
  },
  computed: {
    tableColumn_raw() {
      return [
        {type: 'seq', width: 50},
        {title: this.$t('event.stock_code'), field: "ticker", className: "click-cell-style"},
        {title: this.$t('common.company_name'), field: "official_name", className: "click-cell-style"}
      ]
    }
  }
}
Vue.component("esg-filter", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_filter.js